import properties from 'resources/constants/properties.json';

const FUNCTIONS_NAMESPACE = properties.functionsNamespace
export default(() => ({
  LOAD_FILE: `${FUNCTIONS_NAMESPACE}.GET.FILE`,
  LOAD_TS: `${FUNCTIONS_NAMESPACE}.GET.TS`,
  LOAD_TS_DATAPOINT: `${FUNCTIONS_NAMESPACE}.GET.TS.DATAPOINT`,
  LOAD_FC: `${FUNCTIONS_NAMESPACE}.GET.FC`,
  LOAD_FC_DATAPOINT:  `${FUNCTIONS_NAMESPACE}.GET.FC.DATAPOINT`,
  REFRESH: `${FUNCTIONS_NAMESPACE}.REFRESH`,
  REFRESH_ALL: `${FUNCTIONS_NAMESPACE}.REFRESH.ALL`,
}))()